module.exports = __webpack_public_path__ + "media/styles/images/svg/people-teal-21e568d710c989b3542e8675ff5cf844.svg";